import Fonts from '../../../../shared/assets/style/default/fonts';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const ChannelChoiceDescription = styled.p`
  color: white;
  font-size: ${30 * Screen.widthRatio}px;
  font-family: ${Fonts['regular']};
  line-height: ${40 * Screen.widthRatio}px;
  margin-left: ${224 * Screen.widthRatio}px;
  width: 82%;
  margin-bottom: 0;
`;

export default ChannelChoiceDescription;
